module.exports = __webpack_public_path__ + "static/media/material-location-searching.f2bc5259.svg";